export default __webpack_public_path__ + "static/media/d_wdt_c_5.4b7e9720.mp3";